import React from 'react';
import { RatingStars } from './ui/RatingStars';
import { CheckCircle2, Calendar, ShieldCheck } from 'lucide-react';
// Get date 2 months in the past
function getUpdateDate() {
  const now = new Date();
  const twoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1);
  const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  const month = monthNames[twoMonthsAgo.getMonth()];
  const year = twoMonthsAgo.getFullYear();
  return {
    month,
    year
  };
}
export function ReviewHero() {
  const {
    month,
    year
  } = getUpdateDate();
  const currentYear = new Date().getFullYear();
  return <div className="bg-white border-b border-slate-200 pb-12 pt-16" data-id="element-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex flex-col md:flex-row gap-8 items-start md:items-center justify-between" data-id="element-102">
          <div className="flex-1" data-id="element-103">
            <div className="flex items-center space-x-2 mb-4" data-id="element-104">
              <span className="bg-blue-600 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider rounded-sm" data-id="element-105">
                Testbericht {currentYear}
              </span>
              <span className="text-slate-500 text-sm flex items-center" data-id="element-106">
                <Calendar className="w-3 h-3 mr-1" data-id="element-107" />
                Aktualisiert: {month} {year}
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-slate-900 tracking-tight mb-4" data-id="element-108">
              CRM Kraft im Test: <br className="hidden md:block" data-id="element-109" />
              <span className="text-blue-700" data-id="element-110">
                Ehrliche Bewertung & Analyse
              </span>
            </h1>

            <p className="text-lg text-slate-600 max-w-2xl mb-6 leading-relaxed" data-id="element-111">
              Wir haben das KI-gestützte CRM-System von CRM Kraft unter die Lupe
              genommen. Wie gut funktioniert die Lead-Priorisierung wirklich und
              für wen lohnt sich der Umstieg?
            </p>

            <div className="flex flex-wrap gap-4 text-sm text-slate-600" data-id="element-112">
              <div className="flex items-center" data-id="element-113">
                <ShieldCheck className="w-4 h-4 text-emerald-600 mr-2" data-id="element-114" />
                Unabhängig geprüft
              </div>
              <div className="flex items-center" data-id="element-115">
                <CheckCircle2 className="w-4 h-4 text-emerald-600 mr-2" data-id="element-116" />
                Verifizierte Ergebnisse
              </div>
            </div>
          </div>

          {/* Rating Card */}
          <div className="w-full md:w-auto bg-slate-50 rounded-xl p-6 border border-slate-200 shadow-sm min-w-[280px]" data-id="element-117">
            <div className="text-center" data-id="element-118">
              <span className="block text-sm font-medium text-slate-500 uppercase tracking-wide mb-1" data-id="element-119">
                Gesamturteil
              </span>
              <div className="flex items-center justify-center space-x-2 mb-2" data-id="element-120">
                <span className="text-5xl font-bold text-slate-900" data-id="element-121">4.5</span>
                <span className="text-xl text-slate-400 font-medium" data-id="element-122">/ 5</span>
              </div>
              <div className="flex justify-center mb-4" data-id="element-123">
                <RatingStars rating={4.5} size="lg" data-id="element-124" />
              </div>
              <div className="text-sm text-emerald-700 font-semibold bg-emerald-50 py-2 px-4 rounded-lg inline-block border border-emerald-100" data-id="element-125">
                "Sehr Empfehlenswert"
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}